export const COMPANY_INFORMATION_TAG_NAME = 'tm-bo-company-information';
export const SUMMARY_TAG_NAME = 'tm-bo-company-information-summary';
export const ABOUT_CARD_TAG_NAME = 'tm-bo-company-information-about-card';
export const AUTH_CARD_TAG_NAME = 'tm-bo-company-information-auth-card';
export const RECENT_COMPANY_USERS_TAG_NAME = 'tm-bo-recent-company-users-card';
export const STAT_TILES_TAG_NAME = 'tm-bo-company-info-stat-tiles';
